import tooltips from '../tooltips.js'

export default function () {
  document.addEventListener('DOMContentLoaded', () => {
    tooltips()

    // Handle show all specialisms button.
    const specialismsBtn = document.querySelector('#js__specialismShowAllButton')
    specialismsBtn?.addEventListener(
      'click',
      function () {
        const nodes = document.querySelectorAll('.js__specialismListItem')
        for (let i = nodes.length - 1; i >= 0; i--) {
          nodes[i].style.display = ''
        }

        specialismsBtn.style.display = 'none'
      },
      { once: true }
    )

    // Handle show all approaches button.
    const approachesBtn = document.querySelector('#js__approachShowAllButton')
    approachesBtn?.addEventListener(
      'click',
      function () {
        const nodes = document.querySelectorAll('.js__approachListItem')
        for (let i = nodes.length - 1; i >= 0; i--) {
          nodes[i].style.display = ''
        }

        approachesBtn.style.display = 'none'
      },
      { once: true }
    )

    // Handle "read more" truncation buttons.
    const readMoreBtns = document.querySelectorAll('.js__readMore')
    for (const btn of readMoreBtns) {
      btn.addEventListener(
        'click',
        function () {
          this.parentElement.querySelector('.js__truncated').style.display = 'none'
          this.parentElement.querySelector('.js__untruncated').style.display = 'block'
          this.style.display = 'none'
        },
        { once: true }
      )
    }

    // Handle expand and collapse of specialism list items.
    const elements = document.querySelectorAll('.js__specialismSpan')
    for (let i = elements.length - 1; i >= 0; i--) {
      elements[i].addEventListener('click', function () {
        const children = this.parentElement.querySelector('p')
        children.style.display =
          !children.style.display || children.style.display === 'none' ? 'block' : 'none'
      })
    }
  })
}
